import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { profileService } from "../../services/profile";

export const MY_PROFILE_QUERY_KEY = ["getMyProfile"];

export const useGetMyProfile = () => {
  const queryClient = useQueryClient();

  const { data, isLoading, refetch } = useQuery({
    queryKey: MY_PROFILE_QUERY_KEY,
    staleTime: Infinity,
    queryFn: profileService.get,
  });

  const get = useCallback(async () => {
    const user = await refetch();

    return user?.data?.data;
  }, [refetch]);

  const check = useCallback(async () => {
    const user = await queryClient.fetchQuery({
      queryKey: MY_PROFILE_QUERY_KEY,
      queryFn: profileService.get,
    });

    return user?.data;
  }, [queryClient]);

  const invalidate = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: MY_PROFILE_QUERY_KEY });
  }, [queryClient]);

  // const hasWithdrawMethod = useMemo(() => {
  //   return data?.data?.withdrawalMethodDataUser?.find((method) => {
  //     return !!method?.binding
  //   })
  // }, [data?.data?.withdrawalMethodDataUser])

  const userData = useMemo(() => data?.data, [data]);

  return {
    user: userData,
    // paymentAgent: userData?.paymentAgent?.[0],
    // userFace: userData?.userFace?.[0],
    // hasWithdrawMethod,
    isLoading,
    invalidate,
    check,
    get,
  };
};
